import React from 'react';

export default React.lazy(() => import('./blueprint-data-history'));
